import { z } from 'zod';
import { LEVELS, ROLES, CATEGORIES, DEFINITION_KINDS, define } from '../types.js';
import { MoveTypeSchema, MoveTypes } from './default-move-type.js';

/**
 * Move types available for booking.
 */
export const schema = z.array(MoveTypeSchema);

export type AllowedMoveTypes = z.infer<typeof schema>;

export const definition = define({
  key: 'allowed_move_types',
  schema,
  label: 'Allowed Move Types',
  description:
    'Choose which move types are allowed for clients at this level in the move planner. More often than not, there is no reason to restrict a client unless they request/require it.',
  kind: DEFINITION_KINDS.SETTING,
  category: CATEGORIES.MOVE_PLANNING.key,
  writableAtLevels: [
    LEVELS.HOPDRIVE,
    LEVELS.REGION,
    LEVELS.ORGANIZATION,
    LEVELS.CUSTOMER,
    LEVELS.WORKFLOWSET,
    LEVELS.RATERULEGROUP,
  ],
  readableByRoles: [ROLES.ADMIN],
  defaultValue: MoveTypes,
});
